/*
 * Copyright (c) Dito Technologies LLC
 */

import React, {Dispatch} from "react";
import style from "./RootWorkspace.module.scss";
import {Action, State, StepType} from "ui/feature/root/FormReducer";
import UploadWorkspace from "ui/feature/root/upload/UploadWorkspace";
import StaffSelectWorkspace from "ui/feature/root/staff-select/StaffSelectWorkspace";
import NoteSelectWorkspace from "ui/feature/root/note-select/NoteSelectWorkspace";
import PlayWorkspace from "ui/feature/root/play/PlayWorkspace";
import {QueryRenderer} from "react-relay";
import {RootWorkspaceQuery, RootWorkspaceQuery$data} from "ui/feature/root/__generated__/RootWorkspaceQuery.graphql";
import query from "./RootWorkspaceQuery"
import environment from "constants/environment";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";

interface Props {
    state: State;
    dispatch: Dispatch<Action>;
}

const RootWorkspace: React.FC<Props> = ({state, dispatch}) => {

    const getComponent = React.useCallback((data: RootWorkspaceQuery$data | null, retry: (() => void) | null) => {
        switch (state.selectedStep) {
            case StepType.UPLOAD:
                return <UploadWorkspace state={state} dispatch={dispatch}/>;
            case StepType.STAFF_SELECT:
                return <StaffSelectWorkspace retry={retry} piece={data?.music_viewer.piece || null} dispatch={dispatch} state={state}/>;
            case StepType.VERIFY_NOTES:
                return <NoteSelectWorkspace piece={data?.music_viewer.piece || null} retry={retry} state={state} dispatch={dispatch}/>;
            default:
                return <PlayWorkspace state={state}/>
        }
    }, [state, dispatch])

    if (!state.pieceId) {
        return (
            <div className={style.container}>
                {getComponent(null, null)}
            </div>
        )
    } else {
        return (
            <QueryRenderer<RootWorkspaceQuery>
                environment={environment}
                query={query}
                variables={{piece_id: state.pieceId || ""}}
                render={({props, error, retry}) => {
                    if (props) {
                        return (
                            <div className={style.container}>
                                {getComponent(props, retry)}
                            </div>
                        )
                    } else if (error) {
                        // TODO: check this
                        return <ErrorSection />;
                    } else {
                        // TODO: Maybe make this prettier
                        return <LoadingSection />;
                    }
                }} />
        );
    }
}

export default RootWorkspace;